import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <motion.header 
      className="header"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container">
        <div className="nav-content">
          <a href="#home" className="logo">
            <img src="/logo192.png" className="logo-icon" alt="Logo" />
            <span className="logo-text">斷界召喚</span>
          </a>
          
          <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
            <div className="nav-item">
              <a href="#home" className="nav-link">首頁</a>
            </div>
            <div className="nav-item">
              <a href="#features" className="nav-link">遊戲特色</a>
            </div>
            <div className="nav-item">
              <a href="#zones" className="nav-link">世界區域</a>
            </div>
          </nav>

          <button className="mobile-menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
